import { render, staticRenderFns } from "./sidebar-float.vue?vue&type=template&id=2973b79d&scoped=true&"
import script from "./sidebar-float.vue?vue&type=script&lang=js&"
export * from "./sidebar-float.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-float.vue?vue&type=style&index=0&id=2973b79d&lang=stylus&scoped=true&"
import style1 from "./sidebar-float.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973b79d",
  null
  
)

export default component.exports